import { MeasurementTypeAdapter, Resources } from "@validereinc/domain";
import { NON_INVALIDATING_QUERY_OPTIONS } from "./adapterUtils";
import { useQuery } from "@tanstack/react-query";

export const useListMeasurementTypes = () =>
  useQuery({
    queryKey: [Resources.MEASUREMENT_TYPE, "getList"],
    queryFn: () => MeasurementTypeAdapter.listMeasurementTypes(),
    ...NON_INVALIDATING_QUERY_OPTIONS,
  });
